export default __webpack_public_path__ + "static/desk01-2d7463e576a817d563111b0a4c3e9f88.png";